/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type { HTTPValidationError, ResetUserRequest } from './platformapi.schemas';

import resetUserTypeMutator from '../custom-axios-instance';

/**
 * Deletes any existing user or org application record and updates user type
 * @summary Reset User Type
 */
export const resetUserType = (resetUserRequest: ResetUserRequest, signal?: AbortSignal) => {
  return resetUserTypeMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/users/reset-user-type`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: resetUserRequest,
    signal,
  });
};

export const getResetUserTypeMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetUserType>>,
    TError,
    { data: ResetUserRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetUserType>>,
  TError,
  { data: ResetUserRequest },
  TContext
> => {
  const mutationKey = ['resetUserType'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetUserType>>,
    { data: ResetUserRequest }
  > = (props) => {
    const { data } = props ?? {};

    return resetUserType(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetUserTypeMutationResult = NonNullable<Awaited<ReturnType<typeof resetUserType>>>;
export type ResetUserTypeMutationBody = ResetUserRequest;
export type ResetUserTypeMutationError = void | HTTPValidationError;

/**
 * @summary Reset User Type
 */
export const useResetUserType = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resetUserType>>,
      TError,
      { data: ResetUserRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resetUserType>>,
  TError,
  { data: ResetUserRequest },
  TContext
> => {
  const mutationOptions = getResetUserTypeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
